import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import type { FormCheckboxControl } from '@angular/forms/signals';
import { UiFieldControl } from '../../../basics/ui-field-control';
import { getRandomId } from '../../../utils/get-random-id';
import { SwitchToggleSizeType } from '../../../types';

@Component({
  selector: 'fr8bot-ui-switch-toggle-field',
  templateUrl: './switch-toggle-field.component.html',
  styleUrl: './switch-toggle-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchToggleFieldComponent extends UiFieldControl implements FormCheckboxControl {
  readonly checked = model(false);
  readonly size = input<SwitchToggleSizeType>('small');
  /** The space before the slider that separates it from the projected label. */
  readonly labelGap = input(true);

  protected readonly id = getRandomId('switch-toggle');
  protected readonly sizeMap: Record<SwitchToggleSizeType, string> = {
    small: 'switch-toggle--small',
    large: 'switch-toggle--large',
  };

  protected onChange(element: HTMLInputElement): void {
    this.checked.set(element.checked);
    this.touch.emit();
  }
}
